import {createTheme} from '@mui/material/styles';


export const theme = createTheme({
    palette: {
        primary: {
            main: "#F43745",
            light: '#e8e8e8'
        },
        secondary: {
            main: "#F5F7F2",
        },
        info: {
            main: "#fff",
        },
        success: {
            main: "rgba(159,159,159,0.5)"
        }

    },
    typography: {
        fontFamily: ['Poppins', 'Lato', 'sans-serif'].join(',')
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    color: "#F43745",
                    paddingLeft: 26,
                    paddingRight: 26,
                    paddingTop: 8,
                    paddingBottom: 8,
                    borderRadius: 0,
                    fontWeight: 600,
                    textTransform: 'none',
                    fontSize: 20
                }
            },
            defaultProps: {
                variant: "contained",
                color: "secondary"
            }
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                variant: 'filled'
            },

        }, MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 2,
                    backgroundColor: '#fff'
                }
            }
        }, MuiButtonBase: {
            styleOverrides: {
                root: {
                    transition: 'all .4s ease-in-out',
                    borderRadius: 10,
                }
            }
        }, MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 12
                }
            }
        }
        , MuiIconButton: {
            styleOverrides: {
                root: {
                    transition: 'all .2s ease-in-out',
                }
            }
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#F43745"
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    fontSize: 20,
                    fontWeight: 600
                }
            }
        }

    }


})
